var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10.494,
    viewBox: "0 0 6 10.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-down",
    d: "M11.436,15.438,15.4,11.467a.747.747,0,0,1,1.059,0,.756.756,0,0,1,0,1.062l-4.5,4.5a.749.749,0,0,1-1.034.022L6.406,12.532A.75.75,0,0,1,7.465,11.47Z",
    transform: "translate(-11.246 16.681) rotate(-90)",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7a76a4b76545f79cc717b7a9a83cfb4d.svg";
export { ForwardRef as ReactComponent };